'use es6';

import { defaults, isArray, pluck, omit } from './helpers';
export const create = (name, createError, rules, omitExtras = true) => {
  const getKeys = () => Object.keys(rules);

  const mutate = callback => {
    const updatedRules = callback(rules);
    return create(name, createError, updatedRules, omitExtras);
  };

  const validate = (subject, caller, onError) => {
    try {
      getKeys().forEach(key => {
        const {
          types,
          oneOf,
          isOptional
        } = rules[key];
        const entry = subject[key];
        const isDefined = entry !== undefined;
        let type = typeof entry;

        if (isArray(entry)) {
          type = 'array';
        }

        if (isOptional) {
          return;
        }

        if (!isDefined) {
          throw createError(`Missing required ${name} "${key}". ${caller} requires that a value be passed for ${name} "${key}". Received "undefined".`);
        }

        if (type !== 'function' && isArray(oneOf) && oneOf.indexOf(entry) === -1) {
          throw createError(`Invalid ${name}. ${caller} requires that the "${key}" ${name} be one of ["${oneOf.join('", "')}"]. Received "${entry}".`);
        }

        if (isArray(types) && types.indexOf(type) === -1) {
          throw createError(`Invalid ${name}. ${caller} requires that the "${key}" ${name} type be one of ["${types.join('", "')}"]. Received "${type}".`);
        }
      });
    } catch (err) {
      if (onError && typeof onError === 'function') {
        onError(err);
      } else {
        throw err;
      }
    }
  };

  const validateEach = (subject, caller, onError) => {
    try {
      Object.keys(subject).forEach(key => {
        const entry = subject[key];
        validate(entry, caller);
      });
    } catch (err) {
      if (onError && typeof onError === 'function') {
        onError(err);
      } else {
        throw err;
      }
    }
  };

  const normalize = subject => {
    const withDefaults = defaults(subject, pluck('default', rules));

    if (omitExtras) {
      return omit(withDefaults, getKeys(), false);
    }

    return withDefaults;
  };

  const normalizeEach = subject => {
    return Object.keys(subject).reduce((accumulator, key) => {
      const entry = subject[key];
      accumulator[key] = normalize(entry);
      return accumulator;
    }, {});
  };

  return {
    getKeys,
    mutate,
    normalize,
    normalizeEach,
    validate,
    validateEach,
    _peek: () => rules
  };
};